/**
 * Marken-Verzeichnis (sections/brand-directory.liquid): live search over the
 * brand cards and the A–Z bar — letters without matches grey out, the letter
 * of the group in view is highlighted.
 */
const normalize = (value) =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

class BrandDirectory extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-brand-search]');
    this.groups = [...this.querySelectorAll('[data-group]')];
    this.letters = [...this.querySelectorAll('[data-letter]')];
    this.empty = this.querySelector('[data-brand-empty]');
    this.items = [...this.querySelectorAll('[data-name]')].map((el) => ({
      el,
      name: normalize(el.dataset.name || ''),
    }));

    this.onInput = () => this.filter();
    this.input?.addEventListener('input', this.onInput);

    this.observer = new IntersectionObserver((entries) => this.markCurrent(entries), {
      rootMargin: '-35% 0px -60% 0px',
    });
    this.groups.forEach((group) => this.observer.observe(group));
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.onInput);
    this.observer?.disconnect();
  }

  filter() {
    const query = normalize(this.input?.value || '');
    for (const item of this.items) item.el.hidden = query !== '' && !item.name.includes(query);

    let any = false;
    for (const group of this.groups) {
      const visible = group.querySelector('[data-name]:not([hidden])') !== null;
      group.hidden = !visible;
      any ||= visible;
      const letter = this.letters.find((l) => l.dataset.letter === group.dataset.group);
      letter?.classList.toggle('is-filtered', !visible);
    }
    if (this.empty) this.empty.hidden = any;
  }

  /** @param {IntersectionObserverEntry[]} entries */
  markCurrent(entries) {
    const hit = entries.find((entry) => entry.isIntersecting);
    if (!hit || !(hit.target instanceof HTMLElement)) return;
    const current = hit.target.dataset.group;
    for (const letter of this.letters) letter.classList.toggle('is-current', letter.dataset.letter === current);
  }
}

if (!customElements.get('brand-directory')) {
  customElements.define('brand-directory', BrandDirectory);
}
